import * as Yup from 'yup';
import { TargetConfigMetaData } from '../models';
import Freshdesk from './index';

export const FRESHDESK_CONFIG: TargetConfigMetaData = {
  formComponent: Freshdesk,

  initialValues: {
    subdomain: '',
    apiToken: ''
  },

  validationSchema: Yup.object({
    subdomain: Yup.string().trim().required(),
    apiToken: Yup.string().trim().required()
  })
};
